import React from "react";

import "./About.css";


const About = () => {


  return (
    <div className= "about-section container-fluid py-5" >
      <div className="container text-center py-5">
        <h2 className="titles ">À Propos</h2>
        <p className="fs-5 text-justify">
          Fort de plus de <strong>10 ans d'expérience</strong> dans le domaine du transport privé nous offrons un service de haute qualité, fiable et discret.
        </p>
        <p className="fs-5">
          Que ce soit pour des transferts vers l’aéroport,des trajets longues distances, des événements spéciaux ou des rendez-vous professionnels. 
          <p className="fs-5 ">nous nous engageons à rendre votre trajet confortable et serein.</p>
        </p>
        <p className="fs-5">
          Chaque détail compte. Notre priorité est votre <strong>sécurité</strong> votre <strong>ponctualité</strong>, et votre <strong>confort</strong>.
        </p>
      </div>

    </div>
  );
};

export default About;
